import React from 'react';
import ContentCard from '@ajat/design-system/ContentBlocks/ContentCard';
import { ComponentPage, DemoCard, ViewportFrame } from '../../shared';
import { KVALITE } from './contentDemoData';

/* Figma 2699:17078 shows three of the landing's four quality features */
const QUALITY = {
  title: KVALITE.title,
  body: KVALITE.paragraph,
  features: KVALITE.features.slice(0, 3),
};

const STORY = [
  'OVER/LL är konstruerad med generösa sömmar och robust canvas - inte för att se bra ut på en galge, utan för att rymma tre år av patchar, märken och minnen. Varje detalj är en inbjudan att göra plagget till ditt eget.',
  'Dragkedjorna är YKK. Tygvikten är 350g/m². Passformen är testad med verkliga studenter, inte skyltdockor.',
];

export const meta = {
  component: ContentCard,
  componentName: 'ContentCard',
  title: 'Content Card',
  group: 'Content Blocks',
  importPath: '@ajat/design-system/ContentBlocks/ContentCard',
  figmaNode: '2699:17078',
  description:
    'A full-width copy card between the sections of a page (OVER-LL Editions listing «SEO Block»): an H2, paragraphs, an optional row of check-marked features and an optional link, on the M2 card surface inside the layout gutters. Desktop: the features sit side by side, each under a rule; below 1024px they stack and the card padding drops to medium-l. No vertical margin of its own — the page spaces it. The narrow copy / photo tiles BETWEEN product cards are ProductsGrid `tiles`, not this block.',
  props: [
    ['title', 'string', '—', 'Heading (typo-h2, uppercase, gray-975)'],
    ['titleAs', 'elementType', "'h2'", 'Heading element — h3 under a section heading of its own'],
    ['body', 'string | string[]', '—', 'Copy (typo-body-lg, gray-6) — one string per paragraph; paragraphs are one line apart'],
    ['features', 'array', '[]', '[{ title, description? }] — check-marked, a row on desktop, stacked on mobile (the ContentBannerV2 shape)'],
    ['linkLabel', 'string', '—', 'Link text (regular Hyperlink + arrow); no link without it'],
    ['href', 'string', '—', 'Link URL — a real <a href>, so crawlers follow it'],
    ['onClick', 'func', '—', 'Link click handler; without an href the link only runs it (SPA routing)'],
    ['className', 'string', "''", 'Additional CSS class on the section (id / aria-* pass through too)'],
  ],
  propsNote:
    'Renders nothing without a title, copy or features. Skin: the shared M2 card (.ds-card); the feature row colours are component tokens --content-card-feature-rule / -title / -desc (component-tokens.css — Figma paints them with raw hex, snapped to brand grays).',
  usage: [
    {
      title: 'Between listing sections (Editions)',
      code: `import ContentCard from '@ajat/design-system/ContentBlocks/ContentCard';

<ContentCard
  title="Byggd för att hålla"
  body="Vi kompromissar inte med kvalitet. …"
  features={[
    { title: '350g premium canvas', description: 'Tung, strukturerad, vacker' },
    { title: 'Nickelfria knappar', description: 'Industristandard. Håller i år.' },
    { title: '15 000+ broderade stygn per patch', description: 'Tål att bäras utan att blekas' },
  ]}
/>`,
    },
    {
      title: 'Copy + link',
      code: `<ContentCard
  title="Designad för att bära minnen"
  body={[firstParagraph, secondParagraph]}
  linkLabel="Läs mer"
  href="/kvalite"
  onClick={(e) => { e.preventDefault(); navigate('/kvalite'); }}
/>`,
    },
  ],
};

export default function ContentCardPage() {
  return (
    <ComponentPage meta={meta}>
      <DemoCard title="Figma" hint="title + copy + three features · Overall brand matches 2699:17078" flush>
        <ContentCard {...QUALITY} />
      </DemoCard>

      <DemoCard title="Mobile" hint="< 1024px · features stack, medium-l padding" flush>
        <ViewportFrame width={390} height={540} label="ContentCard at 390px">
          <ContentCard {...QUALITY} />
        </ViewportFrame>
      </DemoCard>

      <DemoCard title="Four features" hint="the columns share the width equally" flush>
        <ContentCard title={KVALITE.title} body={KVALITE.paragraph} features={KVALITE.features} />
      </DemoCard>

      <DemoCard title="Copy and link" hint="body as paragraphs · linkLabel + href" flush>
        <ContentCard title="Designad för att bära minnen" body={STORY} linkLabel="Läs mer" href="#" />
      </DemoCard>

      <DemoCard title="Title only" hint="no copy, no features" flush>
        <ContentCard title="Byggd för att hålla" />
      </DemoCard>
    </ComponentPage>
  );
}
